import AuthManager from "Common/AuthManager"
import ServiceWrapper from "Services/ServiceWrapper"
import AppSettings from "Settings/AppSettings"

export const getCategoryById = (categoryid: string) => {
    return new Promise(async (resolve, reject) => {
        const res = await ServiceWrapper.doGet(
            AppSettings.GMS_BACKEND_API_URL + `category/details/${categoryid}`,
            null,
            null,
            AuthManager.getGmsToken()
        )

        if(res.errorfound || !res.data.data) reject("Could not fetch category")
        resolve(res.data.data[0])
    })
}